// extracted by mini-css-extract-plugin
export var details = "_e9-0";
export var inspectorPopover = "_e9-1";